import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DataManagementService} from '../../services/data-management.service';
import {Constants} from '../../constants';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';
import {AppSettings} from '../../../app-settings';
import * as XLSX from 'xlsx';
import { AuthenticationService } from '../../services/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: "app-incoming",
  templateUrl: "./incoming.component.html",
  styleUrls: ["./incoming.component.css"],
})
export class IncomingComponent implements OnInit {
  @ViewChild("uploadIIMBEmailsModal") uploadIIMBEmailsModal: TemplateRef<any>;
  @ViewChild("registrationDetailsModal")
  registrationDetailsModal: TemplateRef<any>;
  @ViewChild("downloadStudentDocumentModal")
  downloadStudentDocumentModal: TemplateRef<any>;
  @ViewChild("editRegistrationDetailsModal")
  editRegistrationDetailsModal: TemplateRef<any>;

  downloadStudentDocument =
    AppSettings.JAVA_API + AppSettings.DOWNLOAD_INCOMING_STUDENT_DOCUMENT;
  downloadRegistrations = AppSettings.DOWNLOAD_REGISTRATIONS;
  downloadRegistrationsCSV = AppSettings.DOWNLOAD_REGISTRATIONS_CSV;
  emailsTemplate = AppSettings.IIMB_EMAILS_TEMPLATE;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  public modalReference: NgbModalRef;
  errorMessage = undefined;
  incomingTerms;
  incomingTermId = "0";
  selectUndefinedOptionValue = undefined;
  registeredStudents;
  oneStudent;
  data: object;
  token;

  termId: number = undefined;
  documentTypeId: number = undefined;
  documentTypesIncoming: any = [];
  incomingStudentFormData: any;
  incomingStudentId: any;
  addressFlag = false;
  country: any;
  pocDetails: any;
  presentTerm: any;
  formData: FormData;
  fileList: FileList;
  file: File;
  visaAttachment = Constants.VISA_ATTACHMENT;
  mbaTranscriptAttachment = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
  photoAttachment = Constants.PHOTO_ATTACHMENT;
  cvAttachment = Constants.RESUME_ATTACHMENT;
  incomingPassportAttachment = Constants.PASSPORT_ATTACHMENT
  isFormDataLoading: boolean = false;
  studentIncomingTermId: any;


  constructor(
    private modal: NgbModal,
    private dmService: DataManagementService,
    private authenticationService: AuthenticationService,
    private toastService: ToastrService,
    private router: Router
  ) {}

  reRender() {
    if (
      this.registeredStudents !== undefined &&
      this.registeredStudents !== null &&
      this.registeredStudents.length !== 0
    ) {
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.registeredStudents = undefined;
          this.getNominations();
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      this.getNominations();
    }
  }

  getNominations(): void {
    this.dmService
      .javaGetDataCallByParameter(
        Constants.INCOMING_REGISTRATIONS,
        this.incomingTermId
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.registeredStudents = response.data.incoming_students;
            this.incomingTerms = response.data.incoming_terms;
            this.documentTypesIncoming = response.data.document_types;
            if (this.registeredStudents.length === 0) {
              this.errorMessage = "There are no students registered yet.";
            } else {
              this.dtTrigger.next();
            }
          } else if (response.status === "fail") {
            if (
              response.hasOwnProperty("message") &&
              response.message !== null
            ) {
              this.errorMessage = response.message;
            } else {
              this.errorMessage =
                "Something went wrong. Please contact support team";
            }
          }
        },
        (error) => {
          console.log(error);
          this.errorMessage = "Server Error";
        }
      );
  }

  getDate(dateTime): string {
    if (
      dateTime === undefined ||
      dateTime === null ||
      dateTime === "" ||
      dateTime === "undefined"
    ) {
      return "";
    }
    return moment(dateTime).format("Do MMM YYYY");
  }

  openRegistrationDetailsModal(student) {
    this.oneStudent = student;
    this.modalReference = this.modal.open(this.registrationDetailsModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  openDownloadDocumentModal() {
    this.modalReference = this.modal.open(this.downloadStudentDocumentModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  downloadStudentDocuments(e) {
    e.preventDefault();
    if (this.termId == undefined || this.documentTypeId == undefined) {
      this.toastService.info(
        "Please select Term and Document Type to download",
        "Required"
      );
      return;
    }
    const finalData = {
      term_id: this.termId,
      document_type_id: this.documentTypeId,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    const fileName = this.getTermName() + "_" + this.getDocumentTypeName();
    const api =
      AppSettings.JAVA_API + AppSettings.DOWNLOAD_INCOMING_STUDENT_DOCUMENTS;
    const that = this;
    let downloadResponse;
    Swal({
      title: "Confirm",
      type: "question",
      text:
        "Documents will be downloaded from " +
        this.getTermName() +
        " Term and " +
        this.getDocumentTypeName(),
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#4cb84c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.downloadFile(finalData, api).subscribe(
            (data) => {
              saveAs(data, fileName + ".zip");
              downloadResponse = { status: true };
              resolve(downloadResponse);
              that.closeModal();
            },
            (error) => {
              downloadResponse = error;
              reject(downloadResponse);
            }
          );
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {});
  }

  getDocumentTypeName() {
    for (let doc of this.documentTypesIncoming) {
      if (doc.document_type_id == this.documentTypeId) {
        return doc.name;
      }
    }
  }

  getTermName() {
    for (let term of this.incomingTerms) {
      if (term.incoming_term_id == this.termId) {
        return term.incoming_term_name;
      }
    }
  }

  openIIMBEmailsUploadModal() {
    this.modalReference = this.modal.open(this.uploadIIMBEmailsModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  disableButton(state) {
    return state === Constants.INCOMING_STUDENT_WITHDRAWN
      ? true
      : state === Constants.INCOMING_STUDENT_NOMINATED;
  }

  displayInfoIcon(state) {
    return (
      state === Constants.INCOMING_STUDENT_NOMINATED ||
      state === Constants.INCOMING_STUDENT_WITHDRAWN
    );
  }

  displayAcceptButton(state) {
    return state !== Constants.INCOMING_STUDENT_ACCEPTED;
  }

  displayRejectButton(state) {
    return state !== Constants.INCOMING_STUDENT_REJECTED;
  }

  fileChange(evt) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) {
      throw new Error("Cannot upload multiple files on the entry");
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* grab first sheet */
      const wsName = wb.SheetNames[0];
      const ws = wb.Sheets[wsName];
      /* save data */
      this.data = XLSX.utils.sheet_to_json(ws, {
        header: ["email", "iimb_email", "iimb_alias", "roll_number"],
        range: 1,
      });
    };
    reader.readAsBinaryString(target.files[0]);
    return this.data;
  }

  uploadIIMBEmails(e) {
    e.preventDefault();
    const finalUploadData = {
      data: this.data,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    const that = this;
    let uploadResponse;
    Swal({
      title: "Confirm",
      type: "question",
      text:
        "You are going to upload " +
        Object.keys(this.data).length +
        " Student IIMB Emails?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#4cb84c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(finalUploadData, Constants.IIMB_EMAILS)
            .subscribe(
              (data) => {
                uploadResponse = data;
                resolve(uploadResponse);
              },
              (error) => {
                uploadResponse = error;
                reject(uploadResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.hasOwnProperty("value")) {
        if (uploadResponse.status === "success") {
          that.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() => that.router.navigate(["application-oia/incoming"]));
          Swal({
            title: "Success",
            type: "success",
            html: "<p>Successfully uploaded Student IIMB Emails.</p>",
          });
          that.closeModal();
        } else if (uploadResponse.status === "fail") {
          if (uploadResponse.hasOwnProperty("message")) {
            Swal({
              type: "error",
              title: "Fail",
              html: uploadResponse.message,
            });
          } else {
            Swal({
              type: "error",
              title: "Fail",
              text: "Unable to upload Student IIMB Emails, Please contact support team.",
            });
          }
        }
      }
    });
  }

  acceptNomination(nomination): void {
    const that = this;
    let acceptNominationResponse;
    const data = {
      incoming_student_id: nomination.incoming_student_id,
      term_id: nomination.term_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    console.log(JSON.stringify(data));
    Swal({
      title: "confirm",
      type: "question",
      html:
        'Do you want to Accept <span style="font-weight: bold">' +
        nomination.first_name +
        " " +
        nomination.last_name +
        "</span> student nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(data, Constants.ACCEPT_NOMINATION)
            .subscribe(
              (resData) => {
                acceptNominationResponse = resData;
                resolve(acceptNominationResponse);
              },
              (error) => {
                acceptNominationResponse = error;
                reject(acceptNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (acceptNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["application-oia/incoming"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Nomination accepted successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (acceptNominationResponse.status === "fail") {
              if (acceptNominationResponse.message !== "null") {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>" + acceptNominationResponse.message + "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to accept Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  rejectNomination(nomination): void {
    const that = this;
    let acceptNominationResponse;
    const data = {
      incoming_student_id: nomination.incoming_student_id,
      term_id: nomination.term_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    console.log(JSON.stringify(data));
    Swal({
      title: "confirm",
      type: "question",
      html:
        'Do you want to Reject <span style="font-weight: bold">' +
        nomination.first_name +
        " " +
        nomination.last_name +
        "</span> student nomination?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#5cb85c",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(data, Constants.REJECT_NOMINATION)
            .subscribe(
              (resData) => {
                acceptNominationResponse = resData;
                resolve(acceptNominationResponse);
              },
              (error) => {
                acceptNominationResponse = error;
                reject(acceptNominationResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    })
      .then(
        function (result) {
          if (result.hasOwnProperty("value")) {
            if (acceptNominationResponse.status === "success") {
              that.router
                .navigateByUrl("/RefreshComponent", {
                  skipLocationChange: true,
                })
                .then(() => that.router.navigate(["application-oia/incoming"]));
              Swal({
                title: "Success",
                type: "success",
                showCancelButton: false,
                showConfirmButton: true,
                html: "<p>Nomination rejected successfully.</p>",
              }).then(
                function (res) {
                  console.log(res);
                },
                function (timer) {
                  console.log(timer);
                }
              );
              that.closeModal();
            } else if (acceptNominationResponse.status === "fail") {
              if (acceptNominationResponse.message !== "null") {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html:
                    "<p>Unable to reject Nomination, " +
                    acceptNominationResponse.message +
                    "</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              } else {
                Swal({
                  type: "error",
                  title: "Fail",
                  showCancelButton: false,
                  showConfirmButton: true,
                  html: "<p>Unable to reject Nomination, Please contact support team.</p>",
                }).then(
                  function (res) {
                    console.log(res);
                  },
                  function (timer) {
                    console.log(timer);
                  }
                );
              }
            }
          }
        },
        function (cancel) {
          console.log(cancel);
        }
      )
      .catch(function (error) {
        console.log(error);
      });
  }


  getFormData(incomingStudentId): void {
    this.incomingStudentId = incomingStudentId;
    this.isFormDataLoading = true;
    this.errorMessage = undefined;
    this.incomingStudentFormData = {};
        this.country = {};
            this.pocDetails = {};

             if (this.modalReference) {
        this.modalReference.close();
    }


 this.modalReference = this.modal.open(
        this.editRegistrationDetailsModal,
        {
            size: "lg",
            backdrop: "static",
            keyboard: false,
        }
    );


    this.dmService
      .javaGetDataCallByParameter(
        Constants.INCOMING_STUDENT_REGISTRATION,
        this.incomingStudentId
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.isFormDataLoading = false; 
            this.incomingStudentFormData =
              response.data.incoming_student_details;
            this.country = response.data.country;
            this.pocDetails = response.data.poc_details;
            this.presentTerm = response.data.present_term;
            this.incomingStudentFormData.dob = this.getDateForRegistrationForm(
              this.incomingStudentFormData.dob
            );
            this.incomingStudentFormData.passport_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.passport_issue_date
              );
            this.incomingStudentFormData.expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.expiry_date
              );
                 this.incomingStudentFormData.visa_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_issue_date
              );
            this.incomingStudentFormData.visa_expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_expiry_date
              );
            this.incomingStudentFormData.current_address_valid_till =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.current_address_valid_till
              );
            this.incomingStudentFormData.period_of_study_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_from
              );
            this.incomingStudentFormData.period_of_study_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_to
              );
            this.incomingStudentFormData.accommodation_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_from
              );
            this.incomingStudentFormData.accommodation_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_to
              );
            // if (this.modalReference) {
            //   this.modalReference.close();
            // }

            // this.modalReference = this.modal.open(
            //   this.editRegistrationDetailsModal,
            //   {
            //     size: "lg",
            //     backdrop: "static",
            //     keyboard: false,
            //   }
            // );
          } else if (response.status === "fail") {
            this.errorMessage = response.message;
          }
        },
        (error) => {
          this.isFormDataLoading = false;
          console.log(error);
          this.errorMessage = "Server Error";
        }
      );
  }

   getFormDataForEdit(incomingStudentId,incomingTermId): void {
    this.incomingStudentId = incomingStudentId;
    this.studentIncomingTermId = incomingTermId
    console.log("studentIncomingTermId",this.studentIncomingTermId);
    this.isFormDataLoading = true;
    this.errorMessage = undefined;
    this.incomingStudentFormData = {};
        this.country = {};
            this.pocDetails = {};

             if (this.modalReference) {
        this.modalReference.close();
    }


 this.modalReference = this.modal.open(
        this.editRegistrationDetailsModal,
        {
            size: "lg",
            backdrop: "static",
            keyboard: false,
        }
    );

     const requestData = {
        incoming_student_id: this.incomingStudentId,
        incoming_term_id: this.studentIncomingTermId
    };


    this.dmService
      .javaPostDataCall(
        requestData,
                Constants.INCOMING_STUDENT_REGISTRATION_BY_TERM_ID,
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.isFormDataLoading = false; 
            this.incomingStudentFormData =
              response.data.incoming_student_details;
            this.country = response.data.country;
            this.pocDetails = response.data.poc_details;
            this.presentTerm = response.data.present_term;
            this.incomingStudentFormData.dob = this.getDateForRegistrationForm(
              this.incomingStudentFormData.dob
            );
              this.incomingStudentFormData.passport_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.passport_issue_date
              );
            this.incomingStudentFormData.expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.expiry_date
              );
                 this.incomingStudentFormData.visa_issue_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_issue_date
              ); 
            this.incomingStudentFormData.visa_expiry_date =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.visa_expiry_date
              );
            this.incomingStudentFormData.current_address_valid_till =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.current_address_valid_till
              );
            this.incomingStudentFormData.period_of_study_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_from
              );
            this.incomingStudentFormData.period_of_study_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.period_of_study_to
              );
            this.incomingStudentFormData.accommodation_from =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_from
              );
            this.incomingStudentFormData.accommodation_to =
              this.getDateForRegistrationForm(
                this.incomingStudentFormData.accommodation_to
              );
            // if (this.modalReference) {
            //   this.modalReference.close();
            // }

            // this.modalReference = this.modal.open(
            //   this.editRegistrationDetailsModal,
            //   {
            //     size: "lg",
            //     backdrop: "static",
            //     keyboard: false,
            //   }
            // );
          } else if (response.status === "fail") {
            this.errorMessage = response.message;
          }
        },
        (error) => {
          this.isFormDataLoading = false;
          console.log(error);
          this.errorMessage = "Server Error";
        }
      );
  }

  getDateForRegistrationForm(dateTime): string {
    if (
      dateTime === undefined ||
      dateTime === null ||
      dateTime === "" ||
      dateTime === "undefined"
    ) {
      return "";
    }
    return moment(dateTime).tz("Asia/Kolkata").format("YYYY-MM-DD");
  }

  uploadIncomingStudentDetails(): void {
    this.incomingStudentFormData.is_final_submitted = true;
    if (this.incomingStudentFormData.incoming_student_id === 0) {
      this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
    }
    if (this.addressFlag === true) {
      this.incomingStudentFormData.permanent_address_line1 =
        this.incomingStudentFormData.current_address_line1;
      this.incomingStudentFormData.permanent_address_line2 =
        this.incomingStudentFormData.current_address_line2;
      this.incomingStudentFormData.permanent_city =
        this.incomingStudentFormData.current_city;
      this.incomingStudentFormData.permanent_country_id =
        this.incomingStudentFormData.current_country_id;
      this.incomingStudentFormData.permanent_zipcode =
        this.incomingStudentFormData.current_zipcode;
    }
    this.incomingStudentFormData["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    this.dmService
      .javaPostDataCall(
        this.incomingStudentFormData,
        Constants.INCOMING_STUDENT_REGISTRATION
      )
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.toastService.success(
              "Successfully updated the registration form.",
              "Success"
            );
            this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
          } else if (response.status === "fail") {
            this.toastService.warning(response.message, "Fail");
          }
        },
        (error) => {
          console.log(error);
          this.toastService.error("Server Error", "Error");
        }
      );
  }

  sameAsCurrentAddress(): void {
    this.addressFlag = !this.addressFlag;
  }

  finalSubmitRegistrationForm(e): void {
    e.preventDefault();
    this.incomingStudentFormData.is_final_submitted = true;
    if (this.incomingStudentFormData.incoming_student_id === 0) {
      this.incomingStudentFormData.incoming_student_id = this.incomingStudentId;
    }
    if (this.addressFlag === true) {
      this.incomingStudentFormData.permanent_address_line1 =
        this.incomingStudentFormData.current_address_line1;
      this.incomingStudentFormData.permanent_address_line2 =
        this.incomingStudentFormData.current_address_line2;
      this.incomingStudentFormData.permanent_city =
        this.incomingStudentFormData.current_city;
      this.incomingStudentFormData.permanent_country_id =
        this.incomingStudentFormData.current_country_id;
      this.incomingStudentFormData.permanent_zipcode =
        this.incomingStudentFormData.current_zipcode;
    }
    this.incomingStudentFormData["user_id"] = JSON.parse(
      localStorage.getItem("epas_user")
    ).user_id;
    const that = this;
    let uploadResponse;
    Swal({
      title: "Confirm",
      type: "question",
      text: " Are you sure you want to continue?",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#4cb84c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService
            .javaPostDataCall(
              that.incomingStudentFormData,
              Constants.FINAL_INCOMING_STUDENT_REGISTRATION
            )
            .subscribe(
              (data) => {
                uploadResponse = data;
                resolve(uploadResponse);
              },
              (error) => {
                uploadResponse = error;
                reject(uploadResponse);
              }
            );
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.hasOwnProperty("value")) {
        if (uploadResponse.status === "success") {
          that.router
            .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
            .then(() =>
              that.router.navigate(["application-oia/incoming"], {
                replaceUrl: true,
              })
            );
          if (uploadResponse.hasOwnProperty("message")) {
            Swal({
              title: "Success",
              type: "success",
              html: uploadResponse.message,
            });
          } else {
            Swal({
              title: "Success",
              type: "success",
              html: "<p>Successfully submitted registration.</p>",
            });
          }
          that.closeModal();
        } else if (uploadResponse.status === "fail") {
          if (uploadResponse.hasOwnProperty("message")) {
            Swal({
              type: "error",
              title: "Fail",
              html: uploadResponse.message,
            });
          } else {
            Swal({
              type: "error",
              title: "Fail",
              text: "Unable to upload registration form, Please contact support team.",
            });
          }
        }
      }
    });
  }

  editFileChange(event, documentId) {
    if (event.target.files.length > 1) {
      throw new Error("Cannot upload multiple files on the entry");
    }
    this.fileList = event.target.files;
    const userId = JSON.parse(localStorage.getItem("epas_user")).user_id;
    this.file = event.target.files[0];
    this.formData = new FormData();
    this.formData.append("file", this.file);
    this.formData.append(
      "incoming_student_id",
      this.incomingStudentFormData.incoming_student_id
    );
    this.formData.append("document_type_id", documentId);
    this.formData.append("user_id", userId);
    this.uploadDocument();
  }

  uploadDocument() {
    if (this.formData === undefined || this.formData === null) {
      this.toastService.warning("Please select the file and .", "Required");
      return;
    }
    this.dmService.javaUploadIncomingStudentDocument(this.formData).subscribe(
      (response) => {
        if (response.status === "success") {
          this.formData = undefined;
          this.toastService.success(
            "Successfully uploaded the file " + this.file.name,
            "Success"
          );
          this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
        } else if (response.status === "fail") {
          if (response.hasOwnProperty("message")) {
            this.toastService.warning(response.message, "Fail");
          } else {
            this.toastService.warning(
              "Something went wrong. please contact support team",
              "Fail"
            );
          }
        }
      },
      (error) => {
        console.log(error);
        this.toastService.warning(
          "Something went wrong. please contact support team",
          "Fail"
        );
      }
    );
  }

  deleteDocument(documentId) {
    console.log("delete document called for documentId " + documentId);
    const finalData = {
      incoming_student_id: this.incomingStudentFormData.incoming_student_id,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };
    if (documentId === Constants.VISA_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.visa_attachment_id;
      finalData["document_type_id"] = Constants.VISA_ATTACHMENT;
    } else if (documentId === Constants.LATEST_TRANSCRIPT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.latest_transcript_attachment_id;
      finalData["document_type_id"] = Constants.LATEST_TRANSCRIPT_ATTACHMENT;
    } else if (documentId === Constants.PASSPORT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.passport_attachment_id;
      finalData["document_type_id"] = Constants.PASSPORT_ATTACHMENT;
    } else if (documentId === Constants.PHOTO_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.photo_attachment_id;
      finalData["document_type_id"] = Constants.PHOTO_ATTACHMENT;
    } else if (documentId === Constants.RESUME_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.resume_attachment_id;
      finalData["document_type_id"] = Constants.RESUME_ATTACHMENT;
    } else if (documentId === Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.hostel_coc_attachment_id;
      finalData["document_type_id"] =
        Constants.HOSTEL_CODE_OF_CONDUCT_ATTACHMENT;
    } else if (documentId === Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.release_cum_identity_bond_attachment_id;
      finalData["document_type_id"] =
        Constants.RELEASE_CUM_IDENTITY_BOND_ATTACHMENT;
    } else if (documentId === Constants.HEALTH_CERTIFICATE_ATTACHMENT) {
      finalData["document_id"] =
        this.incomingStudentFormData.health_certificate_attachment_id;
      finalData["document_type_id"] = Constants.HEALTH_CERTIFICATE_ATTACHMENT;
    }
    this.dmService
      .javaPostDataCall(finalData, Constants.INCOMING_STUDENT_FILE_DELETE)
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.toastService.success(
              "Successfully deleted the file ",
              "Success"
            );
            this.getFormDataForEdit(this.incomingStudentId,this.studentIncomingTermId);
          } else if (response.status === "fail") {
            if (response.hasOwnProperty("message")) {
              this.toastService.warning(response.message, "Fail");
            } else {
              this.toastService.warning(
                "Something went wrong. please contact support team",
                "Fail"
              );
            }
          }
        },
        (error) => {
          console.log(error);
          this.toastService.warning(
            "Something went wrong. please contact support team",
            "Fail"
          );
        }
      );
  }

  closeModal(): void {
    this.modalReference.close();
    this.oneStudent = undefined;
    this.termId = undefined;
    this.documentTypeId = undefined;

    this.incomingStudentId = undefined;
    this.studentIncomingTermId = undefined;
    this.incomingStudentFormData = {};
    this.country = {};
    this.pocDetails = {};
    this.isFormDataLoading = false;
    this.errorMessage = undefined;
  }

  downloadAcceptedAdmissionLetters(e) {
    e.preventDefault();

    if (this.incomingTermId === "0" || this.incomingTermId === undefined) {
      this.toastService.info(
        "Please select a Term to download admission letters",
        "Required"
      );
      return;
    }
    

    const finalData = {
      term_id: this.incomingTermId,
      user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
    };

    const fileName = this.getSelectedTermName() + "_Admission_Letters";
    const api =
      AppSettings.JAVA_API + AppSettings.DOWNLOAD_ACCEPTED_ADMISSION_LETTERS;
    const that = this;
    let downloadResponse;

    Swal({
      title: "Confirm",
      type: "question",
      text:
        "Admission letters will be downloaded for " +
        this.getSelectedTermName() +
        " term",
      showCancelButton: true,
      confirmButtonClass: "btn btn-outline-success rounded-0",
      cancelButtonClass: "btn btn-outline-danger rounded-0",
      cancelButtonColor: "#d33",
      confirmButtonColor: "#4cb84c",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.downloadFile(finalData, api).subscribe(
            (data) => {
              saveAs(data, fileName + ".zip");
              downloadResponse = { status: true };
              resolve(downloadResponse);
            },
            (error) => {
              downloadResponse = error;
              reject(downloadResponse);
            }
          );
        });
      },
      allowOutsideClick: false,
    })
      .then(function (result) {
        if (result.hasOwnProperty("value")) {
          if (downloadResponse && downloadResponse.status === true) {
            that.toastService.success(
              "Admission letters downloaded successfully",
              "Success"
            );
          }
        }
      })
      .catch(function (error) {
        let errorMessage =
          "An error occurred while downloading admission letters.";

        if (error.error instanceof Blob) {
          error.error.text().then((text) => {
            try {
              const json = JSON.parse(text);
              if (json && json.message) {
                errorMessage = json.message;
              }
            } catch (e) {
              errorMessage = text; // plain text fallback
            }
            // that.toastService.error(errorMessage, "Error");
            that.toastService.error(errorMessage, "Error", {
              timeOut: 10000,
              extendedTimeOut: 2000,
              closeButton: true,
              progressBar: true,
            });
          });
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
          // that.toastService.error(errorMessage, "Error");
          that.toastService.error(errorMessage, "Error", {
            timeOut: 10000,
            extendedTimeOut: 2000,
            closeButton: true,
            progressBar: true,
          });
        } else {
          //that.toastService.error(errorMessage, "Error");

          that.toastService.error(errorMessage, "Error", {
            timeOut: 10000,
            extendedTimeOut: 2000,
            closeButton: true,
            progressBar: true,
          });
        }
        console.error("Download error:", error);
      });
  }

  getSelectedTermName(): string {
    if (!this.incomingTerms || this.incomingTermId === "0") {
      return "Selected Term";
    }

    const selectedTerm = this.incomingTerms.find(
      (term) =>
        term.incoming_term_id.toString() === this.incomingTermId.toString()
    );

    return selectedTerm ? selectedTerm.incoming_term_name : "Selected Term";
  }

  ngOnInit() {
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false,
    };
    this.getNominations();
    this.token = this.authenticationService.getToken();
  }
}
